import PropTypes from 'prop-types';
import { Component } from 'react';
import { bindAll } from 'lodash/fp';
import { ErrorBoundaryDialog } from 'app/components/composite/ErrorBoundaryDialog';

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        bindAll(['resetError'], this);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error) {
        console.error(`[${this.props.prefix}]`, error);
    }

    resetError() {
        this.setState({ hasError: false, error: null });
    }

    render() {
        if (this.state.hasError && this.state.error) {
            return (
                <ErrorBoundaryDialog
                    error={this.state.error}
                    onClose={this.props.onClose ?? this.resetError}
                />
            );
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    prefix: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.node
};

ErrorBoundary.defaultProps = {
    prefix: 'Unhandled Error',
    onClose: null,
    children: null
};
